  <div class="grid" id="headnav">
  <div class="col-12 md:col-2 lg:col-2 sm:col-12">
    <div class="complinity-icon" ></div>
      <span class="version">{{this.currentVersion}}</span>
  </div>
  <div class="col-12 md:col-7 lg:col-7 sm:col-12 center-col">
 <ul class="custom-menubar">
  <li *ngFor="let item of items; let i = index"
      class="custom-menuitem"
      [ngClass]="{ 'open': openIndex === i , 'active-menu-item': isActive(returnurl(item.label))}"
      [pTooltip]="item.title" tooltipPosition="bottom"
      (click)="item.command(); $event.stopPropagation()"
    routerLinkActive="active-menu-item"
      (click)="toggleSubmenu(i, item.items)">
    <span *ngIf="item.icon" class="pi" [ngClass]="item.icon" style="margin-right: 5px;"></span>
    
    {{ item.label }} 
        <i *ngIf="item.label === 'More'" class="pi pi-chevron-down dropdown-icon"
       [ngClass]="{ 'rotate': openIndex === i }" ></i>
    <ul class="submenu" *ngIf="item.items && openIndex === i">
      <li *ngFor="let sub of item.items" (click)="sub.command(); $event.stopPropagation()"
          [ngClass]="{ 'active-menu-item': isActive(returnurl(sub.label)) }">
                <span *ngIf="sub.icon"[ngClass]="sub.icon" style="margin-right: 5px;"></span>
        {{ sub.label }}
      </li>
    </ul>
  </li>
</ul>

  </div>
  
  <div class="col-12 md:col-3 lg:col-3 sm:col-12 rightmenu">
        <!-- <div class="session-timer">
  ⏱ Log in Time: {{ sessionDuration }}
</div> -->
    <app-usersubmenu></app-usersubmenu>
      <i class="fa fa-home lg mr-2 bluehome" pTooltip="Home" tooltipPosition="bottom" (click)="navigateTohome()"></i>
      <span class="mr-2" style="font-size: 22px;">
        <i class="fa fa-question" pTooltip="Help" tooltipPosition="bottom"></i>

      </span>
              <!-- <i class="fa fa-question" pTooltip="Help" tooltipPosition="bottom"></i> -->

      <i class="fa fa-sign-out red-icon" pTooltip="Log Out" (click)="doLogout()" tooltipPosition="left" style="font-size: 22px;"></i>
     
  </div>
    <span class="server-info">
      Logged Server: {{currentserver}} | {{loggedinorg}}
    </span>
  
</div>